// Types related to Completions

export interface MessageDto {
  content?: string;
}

export interface FileData {
  fileName?: string;
  contentType?: string;
  content?: string;
}

export enum MessageType {
  SYSTEM = "SYSTEM",
  USER = "USER",
  AI = "AI",
  ASSISTANT = "ASSISTANT",
  TOOL_EXECUTION_RESULT = "TOOL_EXECUTION_RESULT"
}

/**
 * Request format for creating a completion
 */
export interface CompletionRequestDto {
  message?: string;
  correlation_id?: string;
  user_id?: string;
}

export interface CompletionResponseDto {
  id?: string;
  message?: MessageDto;
  fileData?: FileData[];
  application_id?: string;
  message_type?: MessageType;
  user_id?: string;
  elapsed_time?: number;
  created_at?: string;
  correlation_id?: string;
}

/**
 * Chat source for chat messages
 */
export interface ChatSource {
  type?: string;
  mimeType?: string;
}

/**
 * Chat tool execution for chat messages
 */
export interface ChatToolExecution {
  chatToolRequest?: ChatToolRequest;
  result?: string;
}

/**
 * Chat tool request for chat messages
 */
export interface ChatToolRequest {
  id?: string;
  name?: string;
  arguments?: string;
}

/**
 * Paginated response for user chat messages
 */
export interface PaginatedResponseUserChatMessageDto {
  content: UserChatMessageDto[];
  current_page: number;
  page_size: number;
  total_elements: number;
}

/**
 * User chat message data
 */
export interface UserChatMessageDto {
  id?: string;
  type?: MessageType;
  content?: string;
  sources?: ChatSource[];
  sequence_id?: number;
  correlation_id?: string;
  user_id?: string;
  tool_executions?: ChatToolExecution[];
  provider_name?: string;
  model_name?: string;
  finish_reason?: string;
  input_tokens?: number;
  output_tokens?: number;
  total_tokens?: number;
  created_at?: string;
}